import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  HostBinding,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';

@Component({
  selector: 'app-port-common-table',
  templateUrl: './port-common-table.component.html',
  styleUrls: ['./port-common-table.component.scss'],
})
export class PortCommonTableComponent {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;
  paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  elements: any;
  counter = 1;
  segmentOptions: string[] = getSegmentOptions();
  cargoOperation: string[] = [];
  selectedSegments: string[] = [];
  selectedCargoOperations: string[] = [];
  filteredData: any;
  selectedTab: boolean | undefined;
  pastVoyagesComponent: any;
  data: any;
  shipNameSuggestions: any[] = [];
  tableName: any;
  rawData = [
    {
      actual_cargo_ops_consumption: 78.7,
      actual_idle_consumption: 26.8,
      actual_maneuvering_consumption: 7.0,
      cargo_ops_consumption_design: 53.66,
      idle_consumption_design: 23.83,
      maneuvering_consumption_design: 1.71,
      port_name: 'New Mangalore',
      vessel_imo: 9544281,
      vessel_name: 'CORUM',
      vessel_type: 'Crude oil/product carrier',
    },
  ];

  rawData1 = [
    {
      actual_cargo_ops_consumption: 78.7,
      actual_idle_consumption: 26.8,
      actual_maneuvering_consumption: 7.0,
      cargo_ops_consumption_tcp: 121.86,
      idle_consumption_tcp: 43.17,
      maneuvering_consumption_tcp: 1.71,
      port_name: 'New Mangalore',
      vessel_imo: 9544281,
      vessel_name: 'CORUM',
      vessel_type: 'Crude oil/product carrier',
    },
  ];
  rawData2 = [
    {
      fo_maneuvering_consumption: 7.0,
      go_maneuvering_consumption: 0.0,
      port_name: 'New Mangalore',
      vessel_imo: 9544281,
      vessel_name: 'CORUM',
      vessel_type: 'Crude oil/product carrier',
    },
  ];
  edit: boolean = false;
  activeTab: any;
  mode: any;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private readonly route: ActivatedRoute,
     private pRequestFormService: PortRequestFormServiceService 

  ) {
    this.route.params.subscribe((params) => {
      this.activeTab = params['tab'];
    });
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      segment: ['', [Validators.required]],
      shipName: ['', [Validators.required]],
      imoNumber: ['', [Validators.required]],
      cargoOperation: ['', [Validators.required]],
    });
  }
  ngOnInit() {
    this.updateDataBasedOnTab();
    this.loadData();

    console.log(this.activeTab, 'tab name');
  }
  updateDataBasedOnTab() {
    if (this.activeTab === 'shipUnderperformanceDesign') {
      this.tableName = 'Underperformance Ships (Design)';
      this.mode = 'design';
    } else if (this.activeTab === 'shipUnderperformanceTcp') {
      this.tableName = 'Underperformance Ships (TCP)';
      this.mode = 'tcp';
    } else if (
      ['Idle', 'Transit', 'CargoOperations'].includes(this.activeTab)
    ) {
      this.paginatedData = this.rawData2;
      if (this.activeTab === 'Idle') {
        this.tableName = 'Idle Vessels Table';
         this.mode = 'idle';
      } else if (this.activeTab === 'Transit') {
        this.tableName = 'Transit Vessels Table';
         this.mode = 'maneuvering';
      } else if (this.activeTab === 'CargoOperations') {
        this.tableName = 'Vessels doing cargo operations';
         this.mode = 'cargo-ops';
      }
    }
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }
  refresh() {
    this.loadData();
  }
  loadData() {
    if (
      this.activeTab === 'shipUnderperformanceDesign' ||
      this.activeTab === 'shipUnderperformanceTcp'
    ) {
      this.pRequestFormService.getDesignTcpData(this.mode).subscribe((data) => {
        this.elements = data || [];
        this.cargoOperation = [
          ...new Set(
            this.elements
              .map((item: any) => item?.operations)
              .filter((item: any) => !!item),
          ),
        ] as string[];
        this.paginatedData = this.elements;
      });
    }else{
      this.pRequestFormService.getIdelManCargoData(this.mode).subscribe((data) => {
        this.elements = data || [];
        this.cargoOperation = [
          ...new Set(
            this.elements
              .map((item: any) => item?.operations)
              .filter((item: any) => !!item),
          ),
        ] as string[];
        this.paginatedData = this.elements;
      });
    }
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.elements.filter((item: any) =>
        item.shipName.toLowerCase().includes(inputValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }

  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }
  showDetails(row: any) {
    // this.sharedDataService.setRowData(row);
    this.router.navigate(['/vp-shipView']);
  }
  downloadIcon(ow: any) {
    // this.toastr.success(ToasterMessages.UnderDev);
  }

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
        bunkPrice * (VLSFO || 0) +
        bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }
  clearClick() {
    this.filterForm.reset();
    this.selectedSegments = [];
    this.selectedCargoOperations = [];
    this.loadData();
  }

  filterClick() {
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const selectedSegments = this.selectedSegments.map((s) =>
      String(s).toLowerCase()
    );
    const selectedCargoOperations = this.selectedCargoOperations.map((s) =>
      String(s).toLowerCase()
    );
    const shipName = this.filterForm.get('shipName')?.value;
    const imoNumber = this.filterForm.get('imoNumber')?.value;
    if ((from_date_str && !to_date_str) || (!from_date_str && to_date_str)) {
      // this.toastr.info(ToasterMessages.SelectDate);
      return;
    }
    const formatDateToYYYYMMDD = (dateString: string | null) => {
      if (dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return null;
    };

    const from_date = formatDateToYYYYMMDD(from_date_str);
    const to_date = formatDateToYYYYMMDD(to_date_str);

    const filteredData = this.elements.filter((element: any) => {
      const elementFromDate = element.fromDate
        ? formatDateToYYYYMMDD(element.fromDate)
        : null;

      return (
        (!from_date || (elementFromDate && elementFromDate >= from_date)) &&
        (!to_date || (elementFromDate && elementFromDate <= to_date)) &&
        (!selectedSegments.length ||
          selectedSegments.includes((element.segment || '').toLowerCase())) &&
        (!selectedCargoOperations.length ||
          selectedCargoOperations.includes(
            (element.operations || '').toLowerCase()
          )) &&
        (!shipName ||
          element.shipName?.toLowerCase().includes(shipName.toLowerCase())) &&
        (!imoNumber || element.imoNumber === Number(imoNumber))
      );
    });

    this.filteredData = filteredData;
    // this.sharedDataService.setFilterData(filteredData);

    this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    this.currentPage = 0;
  }
  exportClick() {
    const data = this.filteredData || this.elements;
    const csvHeader =
      'Ship Name,Segment,Time Lost (or) Gain,HSFO,VLSFO,GO,Daily Hire,Avg Bunker Price,Claimable Amount';
    const csvData = data
      .map((item: any) => {
        const bunkLostGain = item.bunkerLostOrGain
          ? `${item.bunkerLostOrGain.HSFO},${item.bunkerLostOrGain.VLSFO},${item.bunkerLostOrGain.GO}`
          : ',,';
        const claimEst = item.claimEst
          ? `${item.claimEst.hire},${item.claimEst.bunkPrice}`
          : ',';
        return `${item.shipName},${item.segment},${
          item.timeLost
        },${bunkLostGain},${claimEst},${this.calculateClaimableAmount(
          item.claimEst
        )}`;
      })
      .join('\n');
    const csvContent = `${csvHeader}\n${csvData}`;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'table_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  printTable() {
    // Use all elements or filteredData based on what you want to print
    const dataToPrint = this.filteredData || this.elements;

    // Generate the HTML content for the table
    const tableHtml = `
        <html>
          <head>
            <style>
            
    .tableTitle {
      display: block;
      position:fixed; 
      top: 0px !important;
      left: 10px !important;
      width: 100%;
      font-size: 1.2em;
      margin-bottom: 10px; 
       color: #766b6b;
       font-family: "Poppins", sans-serif;
       page-break-before: avoid;
    }
    .printable-table {
      position: absolute;
      max-height: 100%;
      top: 50px;
      page-break-inside:avoid;
    }
    .filter{
      display: none;
    }
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
       @page {
                size: A4;
                margin: 0; /* Remove margins */
              }
  
    table {
      width: 100%;
      min-width: 100%;
      border: 0;
      white-space: nowrap;
      border-spacing: 0;
      box-shadow: 0px 0px 20px 0px rgba(82, 63, 105, 0.15);
    }
    th.time {
      white-space: nowrap;
    }
    .scroll-bar {
      overflow-x: scroll !important;
      overflow-y: hidden;
    }
    th,
    td {
      min-width: 85px;
      font-weight: 500;
      font-family: "Poppins", sans-serif;
      text-align: center !important;
      vertical-align: middle;
      padding-top: 0px;
      padding-bottom: 0px;
      font-size: 13px;
    }
    th {
      background-color: #0a4380d9;
      color: white;
      border: 1px solid #8d8e8f;
      padding-left: 5px;
      padding-right: 5px;
    }
    td {
      color: #766b6b;
      white-space: nowrap;
      padding:10px
    }
    tr {
      &:nth-child(even) {
        background-color: #cbeaf0;
      }
      &:nth-child(odd) {
        background-color: #f5fdff;
      }
    }
       .logo {
              position: absolute;
              top: 0px;
              right: 10px;
              width: 65px;
            }
            </style>
          </head>
          <body>
           <img src="../../../assets/images/logo.png" class="logo" />
            <h2 class="tableTitle">Fleet View Table</h2>
            <table class="printable-table">
              <thead>
                <tr>
                 <th   rowspan="2">S.No</th>
                <th   rowspan="2">Ship Name</th>
                <th   rowspan="2">IMO Number</th>
                <th   rowspan="2">Segment</th>
                <th   rowspan="2">Time Lost</th>
                <th colspan="3"> Bunker Lost(-) or Gained(mt)</th>
                </tr>
                <tr>
                  <th class="th-text-center2" mat-sort-header="hsfo"><span>HSFO</span></th>
                  <th class="th-text-center2" mat-sort-header="vlsfo"><span>VLSFO</span></th>
                  <th class="th-text-center2" mat-sort-header="go"><span>GO</span></th>
                </tr>
              </thead>
              <tbody>
                ${dataToPrint
                  .map(
                    (item: any, index: number) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${item.shipName}</td>
                    <td>${item.imoNumber}</td>
                    <td>${item.segment}</td>
                    <td>${item.timeLost}</td>
                    <td>${item.bunkerLostOrGain.HSFO}</td>
                    <td>${item.bunkerLostOrGain.VLSFO}</td>
                    <td>${item.bunkerLostOrGain.GO}</td>
                  </tr>
                `
                  )
                  .join('')}
              </tbody>
            </table>
          </body>
        </html>
      `;

    // Create a new iframe element for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      iframeDocument.open();
      iframeDocument.write(tableHtml);
      iframeDocument.close();

      // Trigger print
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }
  }

  downloadClick() {
    // this.toastr.success(ToasterMessages.UnderDev);
  }
  tabChanged(event: MatTabChangeEvent) {
    // this.selectedTab = !this.selectedTab;
    // if (this.pastVoyagesComponent) {
    //   this.pastVoyagesComponent.refresh();
    // }
  }
  editClick() {
    this.edit = true;
  }
  goBack() {
    this.router.navigate(['/pc-dashboard']);
  }
  onCheckboxChange(event: Event, element: any) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      // const dialogRef = this.dialog.open(VesselStatusPopupComponent, {
      //   width: '400px',
      //   height: '228px',
      //   disableClose: true,
      //   data: {
      //     reasonOptions: element.vessel_status // Pass reason options
      //   }
      // });
      // dialogRef.afterClosed().subscribe((result: any) => {
      //   if (result) {
      //     let payload = { imo: element.imoNumber, reason: result.reason, status: result.status };
      //     this.sharedDataService.updateStatus(payload).subscribe((data:any)=>{
      //       this.edit = false;
      //       this.toastr.success(ToasterMessages.SuccessMessage);
      //       this.loadData();
      //     });
      //   }
      // });
    }
  }
}
